
import _ from "lodash"
import { Base64 } from "js-base64"
import editRecipient from "../drawer/editRecipient.vue"
import couponSelect from "../drawer/couponSelect.vue"
import collectOrder from "../drawer/collectOrder.vue"
import deliveryMethod from "../drawer/deliveryMethod.vue"
import { getCartDetailV2, modifyCartV2, getCouponBillV2 } from "../../api/cart"
import redeemItems from "./redeemItems.vue"
import discountReceived from "./discountReceived.vue"
import bestOffer from "./bestOffer.vue"
import saveMoreOffers from "./saveMoreOffers.vue"
import freeGifts from "./freeGifts.vue"
import wareCard from "./wareCard.vue"
import cartEmpty from "./cartEmpty.vue"
import invalidProducts from "./invalidProducts.vue"
import {
  isChecked,
  soldOut,
  fen2Yuan,
  getNumber,
  getSmallNumber,
  showMessage,
  getRangeStore,
  getRangeSlaveStoreList,
  getItemGroup,
  getWareItems,
  getUniqWares
} from "./js/common.js"
import tooltip from "@/components/tooltip.vue"
import {
  resetStoreInfo,
  isAddressActive,
  tooltipCustomStyle,
  openNoAddressPop,
  getDisplayAddress,
  noAddressCheck,
  getDeliveryMethod,
  getCurrentAddress
} from "@/utils/utils"
import { getLanguage } from "@/plugins/i18n"
import { trackViewCart, trackBeginCheckout, trackAddShippingInfo, handleChangeCartNumber } from "@/utils/track"
import storage from "@/utils/storage"
import { omnichatAddToCart, omnichatRemoveFromCart } from "@/utils/omnichat"
import { getAllWares } from "@/utils/cartResponse"
const MAX_VALUE = 99

export default {
  name: "CartDetail",
  components: {
    redeemItems,
    discountReceived,
    bestOffer,
    saveMoreOffers,
    freeGifts,
    wareCard,
    cartEmpty,
    invalidProducts,
    editRecipient,
    couponSelect,
    collectOrder,
    deliveryMethod,
    tooltip
  },
  data() {
    return {
      lang: "",
      loading: true,
      msgContent: {
        title: this.$t("cart.removeTitle"),
        message: this.$t("cart.removeMessage"),
        cancelText: this.$t("cart.cancel"),
        confirmText: this.$t("cart.remove")
      },
      giftMsgContent: {
        title: this.$t("cart.reminder"),
        message: this.$t("cart.giftMessage"),
        cancelText: this.$t("cart.no"),
        confirmText: this.$t("cart.yesContinue")
      },
      loadingInstance: null,
      data: {},
      store: {},
      list: [],
      slaveStoreList: [], // 从门店信息
      invalidList: [],
      invalidCount: 0,
      deliveryOnlyCount: 0,
      userInfo: {},
      defaultAddress: {},
      recipientVisible: false,
      addressVisible: false,
      couponVisible: false,
      checkedCoupons: [],
      validCoupons: [],
      invalidCoupons: [],
      ruleTitle: "",
      ruleContent: "",
      billInfo: {},
      consignId: "",
      isQuota: false, // 是否限购
      isBillError: false, // 结算接口是否异常
      collectOrderItem: {},
      collectOrderCartList: [],
      deliveryMethodValue: "homeDelivery",
      deliveryMethodVisible: false,
      deliveryMethodOptions: [
        {
          label: this.$t("deliveryMethod.homeDelivery"),
          value: "homeDelivery",
          defaultIcon: "carGray",
          activeIcon: "car"
        },
        {
          label: this.$t("deliveryMethod.clickCollect"),
          value: "clickCollect",
          defaultIcon: "cartClickCollectGray",
          activeIcon: "cartClickCollect"
        }
      ],
      checkoutParams: {}
    }
  },

  computed: {
    // 显示可以选择的区域
    showOptionalArea() {
      return this.loading || (this.list && this.list.length)
    },
    validItems() {
      return this.list.filter(item => !this.soldOut(item))
    },
    validSelectAll() {
      if (!this.validItems || !this.validItems.length) return false
      return true
    },
    isAllSelected() {
      return this.validSelectAll && this.validItems.every(item => this.isChecked(item))
    },
    selectedItems() {
      return this.list.filter(item => this.isChecked(item) && !this.soldOut(item))
    },
    hasSelection() {
      return this.selectedItems.length > 0
    },
    // 是否有从门店
    slaveStore() {
      return this.slaveStoreList.length > 0
    },
    recipientInfo() {
      return {
        name: this.userInfo.userName || this.userInfo.name || "",
        num: this.userInfo.phone || "",
        code: this.userInfo.areaCode || ""
      }
    },
    checkedCouponCodes() {
      return this.checkedCoupons.map(item => item.couponCode)
    },
    checkedCouponLen() {
      return (this.checkedCoupons && this.checkedCoupons.length) || 0
    },
    validCouponLen() {
      return (this.validCoupons && this.validCoupons.length) || 0
    },
    billText() {
      const deliveryFee = this.billInfo.shipping
      const packagingFee = this.billInfo.packaging
      const handlingFee = this.billInfo.baseServiceFee
      if (this.isHomeDelivery) {
        if (deliveryFee > 0 && packagingFee > 0) {
          return this.$t("cart.deliveryAndPackagingFee", {
            deliveryFee: this.fen2Yuan(deliveryFee),
            packagingFee: this.fen2Yuan(packagingFee)
          })
        } else if (deliveryFee > 0 && packagingFee <= 0) {
          return this.$t("cart.onlyDeliveryFee", { deliveryFee: this.fen2Yuan(deliveryFee) })
        } else if (deliveryFee <= 0 && packagingFee > 0) {
          return this.$t("cart.onlyPackagingFee", { packagingFee: this.fen2Yuan(packagingFee) })
        }
      } else if (handlingFee > 0 && packagingFee > 0) {
        return this.$t("cart.handlingAndPackagingFee", {
          handlingFee: this.fen2Yuan(handlingFee),
          packagingFee: this.fen2Yuan(packagingFee)
        })
      } else if (handlingFee > 0 && packagingFee <= 0) {
        return this.$t("cart.onlyHandlingFee", { handlingFee: this.fen2Yuan(handlingFee) })
      } else if (handlingFee <= 0 && packagingFee > 0) {
        return this.$t("cart.onlyPackagingFee", { packagingFee: this.fen2Yuan(packagingFee) })
      }
      return ""
    },
    totalPrice() {
      // 无地址或结算异常用购物车接口，反之用结算接口
      return this.noAddressCheck() || this.isBillError ? this.store.discountPrice : this.billInfo.subtotalPrice
    },
    isHomeDelivery() {
      return this.deliveryMethodValue === "homeDelivery"
    },
    pickupExpenseResponse() {
      return this.store.pickupExpenseResponse || {}
    }
  },

  async mounted() {
    this.$bus.$off("add-cart-success", this.handleAddCartSuccess)
    this.$bus.$on("add-cart-success", this.handleAddCartSuccess)
    this.lang = getLanguage()
    this.deliveryMethodValue = getDeliveryMethod()
    await this.init()
    this.trackCartsList()
    this.listenAddressChange()
  },
  beforeDestroy() {
    this.$bus.$off("add-cart-success", this.handleAddCartSuccess)
    document.removeEventListener("addressChanged", this.trackAddressChange)
  },
  methods: {
    noAddressCheck,
    getDisplayAddress,
    getRangeStore,
    getRangeSlaveStoreList,
    getItemGroup,
    getWareItems,
    getUniqWares,
    getUnitItem(item) {
      const wareList = item.wareList || []
      const result = wareList[0] || {}
      result.beforeCount = result.count
      return item
    },
    toggleDeliveryMethod(value) {
      if (this.deliveryMethodValue === value) return
      this.deliveryMethodValue = value
      this.deliveryMethodVisible = true
    },
    getDisplayStore() {
      const curSelStore = localStorage.getItem("curSelStore") ? JSON.parse(localStorage.getItem("curSelStore")) : {}
      return curSelStore
    },
    getFeeMsgContent(bill) {
      const { billItemVOList = [], remarkList = [] } = bill
      if (billItemVOList && billItemVOList.length) {
        const result = billItemVOList.map(
          (item, index) => `<div style="display: flex;justify-content: space-between;margin-top: ${
            index === 0 ? "0" : "0.16rem"
          };">
            <span>${item.name}</span>
            <span>${item.positive ? "+" : "-"}$${this.fen2Yuan(item.value)}</span></div>`
        )

        return result
      }

      return remarkList || []
    },
    setCollectOrderCartList() {
      // 根据skuId去重并累加count
      const tempObj = {}
      _.cloneDeep(this.list).forEach(item => {
        const skuId = item.skuId
        if (!(skuId in tempObj)) {
          tempObj[skuId] = item
        } else {
          tempObj[skuId].count += item.count
        }
      })
      this.collectOrderCartList = Object.values(tempObj).map(item => ({
        sku: item.skuId,
        skuId: item.skuId,
        count: item.count,
        stock: item.remainingStock
      }))
    },
    handleOpenCollect(val) {
      let proActUrl = {}
      try {
        proActUrl = JSON.parse(val.promotionDisplay.proActUrl)
      } catch (error) {
        console.log(error)
      }
      this.setCollectOrderCartList()
      this.$refs.collectOrder.open({
        title: proActUrl.mTitle,
        promotionId: val.promotionId,
        storeId: proActUrl.mStoreId,
        bestOffer: false
      })
    },
    handleOpenBestOffer(val = {}, type, skuId) {
      let promotionId
      let proActUrl = {}

      // 单品里面未凑成bestoffer的促销
      if (type === "unit") {
        try {
          proActUrl = JSON.parse(val.proActUrl)
          promotionId = proActUrl.mValue
        } catch (error) {
          console.log(error)
        }
      } else {
        promotionId = val.promotionId
        if (val.promotionDisplay && val.promotionDisplay.proActUrl) {
          try {
            proActUrl = JSON.parse(val.promotionDisplay.proActUrl)
          } catch (error) {
            console.log(error)
          }
        }
      }

      this.setCollectOrderCartList()
      this.$refs.collectOrder.open({
        skuId,
        promotionId,
        storeId: proActUrl.mStoreId,
        title: proActUrl.mTitle,
        bestOffer: true
      })
    },
    getItemGroupName(type, store) {
      const result = this.getItemGroup(type, store)
      return result.itemGroupName || ""
    },
    getSaveMoreOrReceivedItems(type, store) {
      const result = this.getItemGroup(type, store)
      const promotionList = []
      ;(result.itemList || []).forEach(item => {
        promotionList.push(...(item.promotionList || []))
      })
      return promotionList
    },
    handleNoStoreError(error) {
      if (error && error.code == "44999") {
        openNoAddressPop()
      }
    },
    tooltipCustomStyle(index) {
      return tooltipCustomStyle(index)
    },
    afterAddressChanged() {
      // 地址切换显示toast
      const isCartAddressChanged = localStorage.getItem("isCartAddressChanged")
        ? JSON.parse(localStorage.getItem("isCartAddressChanged"))
        : false
      if (isCartAddressChanged) {
        localStorage.removeItem("isCartAddressChanged")
        showMessage(this.$t("cart.addressChangedTips"))
      }
    },
    handleAddCartSuccess() {
      this.$nextTick(() => {
        this.init(false)
      })
    },
    async init(isGetMemberInfo = true) {
      this.loading = true
      const params = {
        isCollage: false,
        sort: 0,
        simple: 1
      }
      try {
        const { data: res } = await getCartDetailV2({ param: JSON.stringify(params) })
        if (isGetMemberInfo) {
          this.getMemberInfo()
        }
        await this.setData(res)

        this.afterAddressChanged()
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    getMemberInfo() {
      try {
        this.defaultAddress = getCurrentAddress() || {}
        if (this.isHomeDelivery) {
          const { consignee = "", mobilPhone = "" } = this.defaultAddress
          this.userInfo = {
            userName: consignee
          }
          if (mobilPhone && mobilPhone.includes(" ")) {
            this.userInfo.areaCode = mobilPhone.split(" ")[0]
            this.userInfo.phone = mobilPhone.split(" ")[1]

            if (!this.userInfo.areaCode.includes("+")) {
              this.userInfo.areaCode = "+" + this.userInfo.areaCode
            }
          } else {
            this.userInfo.phone = mobilPhone
          }
        } else {
          this.userInfo = storage.get("accountInfo", { useBase64: true }) || {}
        }
      } catch (error) {
        console.log(error)
      }
    },
    getStoreInfo(data = {}) {
      return {
        mappingType: data.storeInfo && data.storeInfo.mappingType,
        storeId: data.storeId,
        venderId: data.venderId
      }
    },
    getCouponBillParams() {
      const allStores = [this.getStoreInfo(this.store)]
      if (this.slaveStore) {
        this.slaveStoreList.forEach(item => {
          allStores.push(this.getStoreInfo(item))
        })
      }
      const checkedStoreIds = _.uniq(this.selectedItems.map(item => item.storeId))
      const checkedStores = allStores.filter(item => checkedStoreIds.includes(item.storeId))

      // 只有主门店
      const onlyMainStore =
        checkedStores.length === 1 && checkedStores[0] && checkedStores[0].storeId === this.store.storeId

      return {
        addSlaveCoupon: !!(this.checkedCoupons && this.checkedCoupons.length),
        storeId: this.getMasterStoreId(),
        checkedStores,
        tradeMode: !checkedStores.length || onlyMainStore ? "1" : "2"
      }
    },
    getCouponParams() {
      return {
        couponCodeList: this.checkedCouponCodes,
        tradeCouponVOs: this.checkedCoupons.map(item => ({
          couponCode: item.couponCode,
          storeId: item.storeId
        })),
        needHangUp: false
      }
    },
    getCalcCouponParams() {
      return Object.assign({ needHangUp: true }, this.getAddressParams(), this.getCouponBillParams())
    },
    async getCheckout(isManual = false) {
      if (this.noAddressCheck() || !this.hasSelection) {
        this.billInfo = {}
        this.validCoupons = []
        this.invalidCoupons = []
        this.checkedCoupons = []

        if (this.noAddressCheck()) {
          openNoAddressPop()
        }
        return
      }

      try {
        const originParams = isManual ? this.getCouponParams() : { needHangUp: true }

        const clickCollectParams = {}
        if (!this.isHomeDelivery) {
          const curSelStore = this.getDisplayStore()
          Object.assign(clickCollectParams, {
            longitude: curSelStore.lng,
            latitude: curSelStore.lat,
            address2: encodeURIComponent(curSelStore.address)
          })
        }
        const params = Object.assign(
          this.getAddressParams(),
          this.getCouponBillParams(),
          originParams || {},
          clickCollectParams
        )
        this.checkoutParams = _.cloneDeep(params)
        const { data: res } = await getCouponBillV2({ param: JSON.stringify(params) })
        this.isBillError = res.code !== "0000"
        this.isQuota = res.code === "51001" // 限购

        if (!this.isBillError) {
          this.consignId = res.consignId || ""
          this.billInfo = res.billInfoV2 || {}
          this.ruleTitle = res.useInstructionsTitle || ""
          this.ruleContent = res.useManual || ""
          this.validCoupons = (res.couponReponse && res.couponReponse.valid) || []
          this.invalidCoupons = (res.couponReponse && res.couponReponse.invalid) || []
          this.checkedCoupons = this.validCoupons.filter(item => !!item.checked)
        } else if (!this.isQuota && (res.result || res.msg)) {
          showMessage(res.result || res.msg)
        }
      } catch (error) {
        console.log(error)
        this.isBillError = true
      }
    },
    async setData(res) {
      this.list = []
      this.data = res || {}
      this.store = this.getRangeStore(this.data) // 主门店
      this.slaveStoreList = this.getRangeSlaveStoreList(this.data) // 从门店信息
      console.log("this.store===>", this.store)

      // 是否调整过赠品或者换购商品, 1: 是, 0: 否
      if (this.data.changedGiftOrTradeFlag == 1) {
        showMessage(this.$t("cart.changedGiftOrTradeMsg"), this.$t("cart.changedGiftOrTradeMinorMsg"))
      }

      const tip = this.isHomeDelivery
        ? (this.store.deliveryExpense && this.store.deliveryExpense.tip) || ""
        : this.pickupExpenseResponse.minPriceTip || ""
      const rate = this.isHomeDelivery
        ? (this.store.deliveryExpense && this.store.deliveryExpense.rate) || 0
        : this.store.pickupMinPriceFlag === 1
          ? 1
          : 0
      this.$bus.$emit("setOnlineStoreTags", {
        tip,
        rate
      })
      this.$bus.$emit("setCartCount", this.data.checkedCount)

      const bestOfferItems = [...this.getWareItems(2, this.store)]
      this.slaveStoreList.forEach(item => {
        bestOfferItems.push(...this.getWareItems(2, item))
      })
      console.log("bestOfferItems==>", bestOfferItems)
      bestOfferItems.forEach((item, index) => {
        item.wareList.forEach(subItem => {
          // 当刷新购物车时,剩余库存比之前的少,取消勾选并且展示一个提示
          const stock = subItem.remainingStock
          if ((item.itemType === 1 || item.itemType === 3) && stock && subItem.count > stock) {
            subItem.showStockTip = true
            subItem.stockTip = this.$t("cart.stockTips", { stock })
            if (this.isChecked(subItem)) {
              this.toggleWareSelect({ items: [subItem], manualClick: false })
            }
          } else {
            subItem.showStockTip = false
          }
          subItem.index = index
          this.list.push(subItem)
        })
      })
      console.log("this.list===>", this.list)

      this.focusStore()
      this.setInvalidList()
      await this.getCheckout()
    },
    getFocusInfo() {
      const headerEl = document.getElementById("top-box")
      const headerHeight = (headerEl && headerEl.clientHeight) || 0

      const cartPageEl = document.getElementById("cart-page-wrapper")
      const computed = cartPageEl ? window.getComputedStyle(cartPageEl) : null

      const CART_MARGIN_TOP = computed && computed["margin-top"] ? parseFloat(computed["margin-top"]) : 0 // 购物车到header的距离
      const cartAndHeaderGap = CART_MARGIN_TOP - headerHeight

      return { cartAndHeaderGap }
    },
    focusStore() {
      this.$nextTick(() => {
        const { focusStoreId } = this.data
        if (!focusStoreId) return

        const slaveStoreEl = document.getElementById(`slave-store-${focusStoreId}`)
        const { cartAndHeaderGap } = this.getFocusInfo()

        // 主门店
        if (this.store.storeId == focusStoreId) {
          const mainStoreEl = document.getElementById("mainStore")
          window.scrollTo({
            top: mainStoreEl.offsetTop + cartAndHeaderGap,
            behavior: "smooth"
          })
        } else if (slaveStoreEl) {
          // 从门店
          window.scrollTo({
            top: slaveStoreEl.offsetTop + cartAndHeaderGap,
            behavior: "smooth"
          })
        }
      })
    },
    focusDeliveryOnly() {
      this.$nextTick(async () => {
        if (this.$refs.invalidProducts) {
          if (!this.$refs.invalidProducts.isShow) {
            this.$refs.invalidProducts.toggleShow && this.$refs.invalidProducts.toggleShow()
          }
        }

        await this.$nextTick()

        const { cartAndHeaderGap } = this.getFocusInfo()
        const deliveryOnlyEl = document.getElementById("category-wrapper-deliveryOnly")
        window.scrollTo({
          top: deliveryOnlyEl.offsetTop + cartAndHeaderGap,
          behavior: "smooth"
        })
      })
    },
    getStoreGroup(type) {
      return (this.data.storeGroupList || []).find(item => item.storeGroupType === type) || {}
    },
    setInvalidList() {
      this.invalidCount = 0
      this.deliveryOnlyCount = 0

      const cloneStore = _.cloneDeep(this.store)
      const deliveryOnlyItems = this.getWareItems(-1, cloneStore)
      this.deliveryOnlyCount = this.getUniqWares(deliveryOnlyItems).length
      const allCategories = [
        {
          type: "deliveryOnly",
          title: this.$t("cart.deliveryOnlyTitle"), // delivery only
          storeList: deliveryOnlyItems.length ? [cloneStore] : []
        },
        {
          type: "rangeNotNearest",
          title: this.$t("cart.rangeNotNearestTitle"),
          storeList: this.getStoreGroup("UnRange").storeList || []
        },
        {
          type: "rangeStandardDelivery",
          title: this.$t("cart.rangeStandardDeliveryTitle"),
          storeList: this.getStoreGroup("PreOrder").storeList || []
        },
        {
          type: "unRangeStoreGroup",
          title: this.$t("cart.unRangeStoreGroupTitle"),
          storeList: this.getStoreGroup("Express").storeList || []
        }
      ]

      this.invalidList = allCategories.filter(item => item.storeList.length)
      const items = []
      this.invalidList.forEach(item => {
        item.storeList.forEach(storeItem => {
          items.push(...this.getWareItems(item.type === "deliveryOnly" ? -1 : 2, storeItem))
          // 从门店
          if (storeItem.slaveStoreList && storeItem.slaveStoreList.length) {
            storeItem.slaveStoreList.forEach(slaveStoreItem => {
              items.push(...this.getWareItems(item.type === "deliveryOnly" ? -1 : 2, slaveStoreItem))
            })
          }
        })
      })
      this.invalidCount = this.getUniqWares(items).length
    },
    isChecked,
    soldOut,
    fen2Yuan,
    getNumber,
    getSmallNumber,
    // 切换全选
    async toggleSelectAll(checked) {
      if (!this.validSelectAll) return

      try {
        const items = this.validItems.map(item => ({
          ...item,
          count: item.showStockTip ? item.remainingStock : item.count,
          checked: checked ? 1 : 0
        }))
        const { data: res } = await modifyCartV2(this.getParams(items))
        await this.setData(res)
      } catch (error) {
        console.log(error)
        this.handleNoStoreError(error)
      }
    },
    // 删除选中的数据
    handleSelectionDelete() {
      if (!this.hasSelection) return

      this.openMsgBox()
    },
    openMsgBox() {
      this.$refs.messageBox.open()
    },
    closeMsgBox() {
      this.$refs.messageBox.close()
    },
    onCancel() {
      this.closeMsgBox()
    },
    getOmnichatiItem(item) {
      const cloneItem = _.cloneDeep(item)
      return {
        id: cloneItem.skuId,
        name: cloneItem.wareName,
        brand: "",
        category: "",
        variant: "",
        quantity: cloneItem.count,
        price: Number(this.fen2Yuan(cloneItem.unitSinglePrice))
      }
    },
    // 确认删除(主品: mainProduct)
    async confirmDelete({ type = "mainProduct", promotionId, items = [], cb }) {
      console.log("isMainProduct===>", type, promotionId, items)
      const otherParams =
        type === "mainProduct"
          ? {}
          : {
              [`${type}ProId`]: promotionId
            }
      const curItems = type === "mainProduct" ? this.selectedItems : items
      curItems.forEach(item => {
        item.oldCount = _.cloneDeep(item.count)
        item.beforeCount = item.count // 记录之前的count
        item.count = 0 // 删除商品，count为0
      })
      try {
        const { data: res } = await modifyCartV2(this.getParams(curItems, otherParams))
        if (type === "mainProduct") {
          this.closeMsgBox()
        }
        await this.setData(res)

        omnichatRemoveFromCart(curItems.map(item => this.getOmnichatiItem(item)))

        if (cb) {
          cb()
        }
      } catch (error) {
        console.log(error)
        curItems.forEach(item => {
          item.count = item.oldCount
        })
        this.handleNoStoreError(error)
      }
    },
    getWareParams(item, otherParams) {
      return {
        sku: item.skuId,
        checked: item.checked,
        beforeCount: "beforeCount" in item ? item.beforeCount : item.count,
        count: item.count,
        ...otherParams
      }
    },
    getParams(items = [], otherParams = {}) {
      // 根据门店分组
      const tempObj = {}
      items.forEach(item => {
        const storeId = item.storeId
        if (!(storeId in tempObj)) {
          tempObj[storeId] = {
            erpStoreId: storeId,
            wares: [this.getWareParams(item, otherParams)]
          }
        } else {
          tempObj[storeId].wares.push(this.getWareParams(item, otherParams))
        }
      })
      console.log("storeGroup===>", items, Object.values(tempObj))
      return {
        param: JSON.stringify({
          isCollage: false,
          sort: 0,
          simple: 1,
          storeGroup: Object.values(tempObj)
        })
      }
    },
    // 取消勾选bestOffer时合并相同sku
    getBestOfferParamItems(items) {
      const tempObj = {}
      items.forEach(item => {
        const skuId = item.skuId
        if (!(skuId in tempObj)) {
          tempObj[skuId] = item
        } else {
          tempObj[skuId].count += item.count
        }
      })
      return Object.values(tempObj)
    },
    // 切换商品勾选
    async toggleWareSelect({ items = [], manualClick = true, bestOffer = false, promotionInfo = {} }) {
      if (this.soldOut(items[0])) return

      try {
        items.forEach(item => {
          item.oldChecked = _.cloneDeep(item.checked)
          item.checked = this.isChecked(item) ? 0 : 1

          item.oldCount = _.cloneDeep(item.count)
          if (manualClick && item.showStockTip) {
            item.beforeCount = item.count // 记录之前的count
            item.count = item.remainingStock
          }
        })
        const otherParams = bestOffer ? { proId: promotionInfo.promotionId } : {}
        const curItems = bestOffer ? this.getBestOfferParamItems(_.cloneDeep(items)) : items
        const { data: res } = await modifyCartV2(this.getParams(curItems, otherParams))
        await this.setData(res)
        console.log("toggleWareSelect", res, curItems)
      } catch (error) {
        console.log(error)
        items.forEach(item => {
          item.checked = item.oldChecked
          item.count = item.oldCount
        })
        this.handleNoStoreError(error)
      }
    },
    // 删除单个商品
    async handleWareDelete(item) {
      const oldCount = item.count
      try {
        item.beforeCount = item.count // 记录之前的count
        item.count = 0 // 删除商品，count为0
        const { data: res } = await modifyCartV2(this.getParams([item]))
        await this.setData(res)
        console.log("handleWareDelete", res, item)

        // 减购时omnichat需要把当前商品剩余count传过去，如果是在bestoffer中删除单个商品时，count不一定为0，所以需要查找当前商品剩余count
        const cloneItem = _.cloneDeep(item)
        const allWares = getAllWares(res)
        const target = allWares.find(ware => ware.sku === item.skuId)
        if (target) {
          cloneItem.count = target.count
        }
        omnichatRemoveFromCart([this.getOmnichatiItem(cloneItem)])
      } catch (error) {
        console.log(error)
        item.count = oldCount
        this.handleNoStoreError(error)
      }
    },
    async handleNumChange(value, item) {
      if (value <= 0) {
        this.handleWareDelete(item)
        return
      }

      const oldChecked = item.checked
      item.checked = 1
      const oldCount = item.count
      item.beforeCount = item.count // 记录之前的count
      item.count = value
      console.log("item.count==>", item.count)

      try {
        const { data: res } = await modifyCartV2(this.getParams([item]))
        await this.setData(res)
        console.log("handleNumChange", value, item.count)

        if (item.count > oldCount) {
          // 加购
          omnichatAddToCart([this.getOmnichatiItem(item)])
        } else {
          // 减购
          omnichatRemoveFromCart([this.getOmnichatiItem(item)])
        }
        handleChangeCartNumber(value, oldCount, item)
      } catch (error) {
        console.log(error)
        item.checked = oldChecked
        item.count = oldCount
        this.handleNoStoreError(error)
      }
    },
    getAddressParams() {
      const { phone, areaCode, userName, name } = this.userInfo
      const { id, type, unitFloor, buildingEstate, label, lng, lat } = this.defaultAddress
      const encodeName = userName || name
      const params = {
        consignId: id,
        phone: areaCode ? `${areaCode} ${phone}` : phone,
        userName: encodeURIComponent(encodeName),
        type,
        unitFloor: encodeURIComponent(unitFloor),
        buildingEstate: encodeURIComponent(buildingEstate),
        label: encodeURIComponent(label),
        longitude: lng, // '113.28028206682269'
        latitude: lat // '23.138333155834644'
      }

      return params
    },
    getMasterStoreId() {
      let masterStoreId = this.store.storeId

      if (!masterStoreId) {
        const firstSlaveStore = (this.slaveStoreList && this.slaveStoreList[0]) || {}
        masterStoreId = firstSlaveStore.storeInfo && firstSlaveStore.storeInfo.masterStoreId
      }

      return masterStoreId
    },
    openGiftMsgBox() {
      this.$refs.giftMessageBox && this.$refs.giftMessageBox.open()
    },
    closeGiftMsgBox() {
      this.$refs.giftMessageBox && this.$refs.giftMessageBox.close()
    },
    confirmCheckout() {
      this.trackBeginCheckout()
      try {
        const { phone, areaCode, userName, name } = this.userInfo
        const encodeName = userName || name
        const otherParams = {
          masterStoreId: this.getMasterStoreId(),
          phone: areaCode ? `${areaCode} ${phone}` : phone,
          userName: encodeURIComponent(encodeName)
        }

        // 配送模式 传addressId
        if (this.isHomeDelivery) {
          otherParams.addressId = this.defaultAddress.id || ""
        }

        if (this.checkedCoupons && this.checkedCoupons.length) {
          Object.assign(otherParams, this.getCouponParams())
        }

        this.$navigation.push({
          path: "/checkout",
          query: {
            params: Base64.encode(JSON.stringify(Object.assign(this.getCouponBillParams(), otherParams)))
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleCheckout() {
      if (this.noAddressCheck() || !this.hasSelection || (this.isBillError && !this.isQuota)) return

      // 自提模式取货人名称不能为空
      const { userName, name } = this.userInfo
      const pickupName = userName || name
      if (!this.isHomeDelivery && !pickupName) {
        showMessage(this.$t("cart.pleaseEnterPickupName"))

        return
      }

      // selectedGiftNotFullFlag为1时标识赠品未选满，需要弹提示窗
      if (this.store.selectedGiftNotFullFlag == 1) {
        this.openGiftMsgBox()
      } else {
        this.confirmCheckout()
      }
    },
    handleAddressChange() {
      this.deliveryMethodVisible = true
    },
    handleUserInfoChange() {
      this.recipientVisible = true
    },
    onRecipientClose() {
      this.recipientVisible = false
    },
    onRecipientSave({ name, num, code }) {
      this.$set(this.userInfo, "userName", name)
      this.$set(this.userInfo, "phone", num)
      this.$set(this.userInfo, "areaCode", code)
    },
    handleCouponClick() {
      this.couponVisible = true
    },
    onCouponClose(isRefresh = false) {
      this.couponVisible = false
      if (isRefresh) {
        this.getCheckout(true)
      }
    },
    onCouponSave(values = []) {
      this.checkedCoupons = values
      this.getCheckout(true)
    },
    trackCartsList() {
      trackViewCart(this.data)
    },
    trackBeginCheckout() {
      trackBeginCheckout(this.data, this.checkedCouponCodes, this.totalPrice)
    },
    trackAddressChange(event) {
      const address = event.detail
      trackAddShippingInfo(this.selectedItems, this.checkedCouponCodes, this.totalPrice, address)
    },
    listenAddressChange() {
      document.addEventListener("addressChanged", this.trackAddressChange)
    },
    // openCollectOrderDlg(item) {
    //   this.collectOrderVisible = true
    //   this.collectOrderItem = item
    //   this.collectOrderCartList = _.cloneDeep(this.list).map(item => ({
    //     sku: item.sku,
    //     count: item.count
    //   }))
    // },
    onDeliveryMethodClose() {
      this.deliveryMethodVisible = false
      this.deliveryMethodValue = getDeliveryMethod()
    }
  }
}
